/**
 * Created by katarinababic on 21.11.24.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { MeditationEntry } from '../../../Model/Explore/MeditationEntry';
import { ExploreContentViewMeditationPlayer } from './ExploreContentViewMeditationPlayer';
import { ExploreContentViewActivityWorkoutContent } from '../ExploreContentViewActivityWorkout/ExploreContentViewActivityWorkoutContent';
import { ExploreContentViewHostCard } from '../ExploreContentViewHostCard';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const PageContainer = styled.div`
  min-height: 100vh;
  background: #fafafa;
  padding: 32px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const PlayerSection = styled.div`
  width: 100%;
`;

const ContentCard = styled.div`
  display: flex;
  gap: 32px;
  align-items: flex-start;
  width: 100%;
  background: white;
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  animation: ${fadeIn} 0.6s ease-out;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 24px;
    gap: 24px;
  }
`;

const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const SideContent = styled.div`
  flex-shrink: 0;
  width: 280px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export type ExploreContentViewMeditationProps = {
  entry: MeditationEntry;
};

export const ExploreContentViewMeditation: React.FC<ExploreContentViewMeditationProps> = observer(({ entry }) => {
  const narrator = entry.narrators[0];

  return (
    <PageContainer>
      <ContentWrapper>
        <PlayerSection>
          <ExploreContentViewMeditationPlayer entry={entry} />
        </PlayerSection>

        <ContentCard>
          <MainContent>
            <ExploreContentViewActivityWorkoutContent entry={entry} />
          </MainContent>
          <SideContent>
            <ExploreContentViewHostCard host={narrator} />
          </SideContent>
        </ContentCard>
      </ContentWrapper>
    </PageContainer>
  );
});
